import React from "react";
import { Container } from "react-bootstrap";

const Contactanos = () => {
  return (
    <>
      <div className="header-contactanos text-center text-white">
        <Container>
          <h1 className="display-1">Contáctanos</h1>
        </Container>
      </div>
    </>
  );
};

export default Contactanos;
